<template>
  <div class="horizontal-bar">
    <div class="horizontal-bar__wrap">
      <div class="horizontal-bar__title">
        {{ title }}
      </div>
      <div class="horizontal-bar__bar">
        <div class="horizontal-bar__progress" :style="progressStyle"/>
      </div>
    </div>

    <div class="horizontal-bar__points">{{ value }}<span>5</span></div>
  </div>
</template>

<script>
export default {
  name: 'horizontal-bar',

  props: {
    title: {
      type: String,
      required: true,
    },

     value: {
      type: Number,
      default: 0,
      validator: function (value) {
        return value >= 0 && value <= 5;
      },
    }
  },

  computed: {
    progressStyle() {
      return `width: ${this.value*100/5}%;`;
    }
  }
}
</script>

<style lang="scss">
  .horizontal-bar {
    display: flex;
    align-items: flex-end;

    &__wrap {
      flex: 1;
    }

    &__title {
      font-size: 12px;
      line-height: 24px;
      font-weight: bold;
    }

    &__bar {
      position: relative;
      border-radius: 2px;
      background: $blue_8;
      height: 4px;
      flex: 1;
    }

    &__progress {
      background: $blue;
      border-radius: 2px;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
    }

    &__points {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      margin-left: 6px;

      span {
        color: $gray_l;
        &:before {
          content: '/';
          font-weight: normal;
        }
      }
    }
  }
</style>